// Bulgarian

const lang = {
  gateMediaPreviewHeader: 'Също може да ви хареса',
  loadmore: 'Вижте още',
  nextMedia: 'Следваща мултимедия',
  previousMedia: 'Предишна мултимедия',
  closePost: 'Затвори публикация',
  nextPost: 'Следваща публикация',
  previousPost: 'Предишна публикация',
  outOfStock: 'Изчерпано количество',
  numberOfReviews(n) {
    return n === 1 ? 'отзив' : 'отзива'
  },
  reportFormField: 'Моля, въведете съобщение',
  reportPost: 'Докладвай публикация',
  reportFormTitle: 'Искате ли да подадете сигнал за това изображение?',
  reportFormDetails:
    'Ако смятате, че изображението е неподходящо, незаконно или нарушава нечии права, можете да подадете сигнал за съдържанието. Ако подадете сигнал за изображение/текст, модераторите на съдържанието ще бъдат уведомени и ще бъдат предприети съответните действия.',
  reportFormMessagePlaceholder: 'Посочете причина за сигнала',
  reportFormMessageLabel: 'Съобщение',
  reportFormEmailLabel: 'Вашия имейл адрес',
  reportFormSubmitButtonText: 'Изпращане на сигнала',
  reportFormCancelButtonText: 'Отказ',
  reportFormSentTitle: 'Благодарим за Вашия сигнал!',
  reportFormSentCloseButtonText: 'Затвори',
  cardAndTileAriaLabel: 'По-долу е списък на публикации от профили в различни социални мрежи',
  carouselAriaLabel: 'По-долу е въртележка с публикации от профили в различни социални мрежи',
  singleAriaLabel: 'По-долу има публикация от акаунт в социалната мрежа',
  poweredBy: 'Поддържа се от Flowbox',
  postAltText: (userName, date) => {
    const publishedString = date ? ` публикувана на ${date}` : ''
    const createdByString = userName ? ` от ${userName}` : ''
    return `Снимка${createdByString}${publishedString}`
  },
  uploadYourMedia: 'Качете своите медии',
  openTheGate: 'Отворете диалоговия прозорец',
}

export default lang
